import { useTranslation } from 'react-i18next';
import { appStores } from '../lib/app-stores';
import googlePlayBadge from '../assets/images/store-google-play.webp';
import appStoreBadge from '../assets/images/store-app-store.webp';

const stores = [
  { key: 'googlePlay', badge: googlePlayBadge },
  { key: 'appStore', badge: appStoreBadge },
] as const;

export function StoreLinks({
  variant = 'badges',
  badgeClassName = 'h-[47px] w-auto lg:h-14',
  className = '',
}: {
  variant?: 'badges' | 'text';
  badgeClassName?: string;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <div
      className={`${variant === 'badges' ? 'flex flex-wrap gap-3' : 'flex flex-col gap-2'} ${className}`}
    >
      {stores.map(({ key, badge }) => {
        const href = appStores[key];
        const label = t(`footer.appNav.${key}`);
        const content =
          variant === 'badges' ? (
            <img src={badge} alt={label} className={badgeClassName} loading="lazy" />
          ) : (
            label
          );

        return href ? (
          <a
            key={key}
            href={href}
            aria-label={t(`footer.app.${key}`)}
            className="rounded-lg hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-current"
          >
            {content}
          </a>
        ) : (
          <span key={key} className="flex flex-col gap-1" aria-disabled="true">
            <span className="opacity-50">{content}</span>
            <span className="text-xs">{t('downloads.unavailable')}</span>
          </span>
        );
      })}
    </div>
  );
}
